import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogContent } from "../components/DialogContent";
import { TextInput } from "../components/TextInput";
import { DialogTitle } from "../components/DialogTitle";
import { SelectInput } from "../components/SelectInput";
import Typography from "@material-ui/core/Typography";
import { getAvaliableUserRoles } from "../utils/userRoles";
import SelectOrganization from "../containers/SelectOrganization";

export const AddUserDialog = ({
  onCancel,
  onSave,
  saveAvaliable,
  onNameChange,
  onEmailChange,
  onRoleChange,
  onPassChange,
  onPassConfirmChange,
  name,
  email,
  role,
  pass,
  passConfirm,
  passDoNotMatch,
  organizationKey,
  onOrganizationChange
}) => (
  <Dialog scroll="body" onClose={onCancel} open spacing={0}>
    <DialogTitle
      onCancel={onCancel}
      onSave={onSave}
      saveAvaliable={saveAvaliable}
    >
      New User
    </DialogTitle>
    <DialogContent>
      <Typography variant="caption">*Required Inputs</Typography>
      <TextInput label="Name" value={name} onChange={onNameChange} required />
      <TextInput
        label="Email"
        value={email}
        onChange={onEmailChange}
        required
        type="email"
      />
      <br />
      <br />
      <SelectInput
        label="Role*"
        value={role}
        options={getAvaliableUserRoles()}
        onChange={onRoleChange}
      />
      <TextInput
        label="Password"
        value={pass}
        onChange={onPassChange}
        required
        type="password"
      />
      <TextInput
        label="Re-enter Password"
        value={passConfirm}
        onChange={onPassConfirmChange}
        required
        error={passDoNotMatch}
        type="password"
      />
      <br />
      <br />
      <SelectOrganization
        value={organizationKey}
        onChange={onOrganizationChange}
      />
    </DialogContent>
  </Dialog>
);
